import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "282",
  "slug": "spot-canada-from-satellite-imagery",
  "title": "How to Recognise Canada in Satellite Images",
  "excerpt": "Southern central Canada contains broad agricultural plains, while much of the Canadian Shield is a mixture of exposed rock, forest, and lakes.",
  "date": "2026-05-19",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/canada.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Southern central Canada contains broad agricultural plains, while much of the Canadian Shield is a mixture of exposed rock, forest, and lakes. The Rockies form a western mountain belt. A view of the Arctic islands looks very different from either the southern prairie or the forested east."
    },
    {
      "type": "heading",
      "text": "Prairies, lakes, and the Canadian Shield"
    },
    {
      "type": "paragraph",
      "text": "Compare the prairie landscape west of Lake Winnipeg with the lake-rich Shield to its east. Keep a wider map open to follow where the terrain changes."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "The US northern plains continue into the Canadian Prairies, and boreal forest occurs across Alaska and Russia too. Fields and conifers can narrow a landscape type without identifying which side of a border you are viewing."
    }
  ],
  "imageAlt": "Canada regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
